import {NavLink} from "react-router-dom";
import styled from "@emotion/styled";
import {PrimaryButton, PrimaryDarkButton, SecondaryButton} from "./Buttons";

export const BaseExternalLink = styled.a``;

BaseExternalLink.defaultProps = {
	target: "_blank",
	rel: "noreferrer noopener",
};

export const PrimaryLink = PrimaryButton.withComponent(NavLink);

export const PrimaryExternalLink = PrimaryButton.withComponent(BaseExternalLink);

export const SecondaryLink = SecondaryButton.withComponent(NavLink);

export const SecondaryExternalLink = SecondaryButton.withComponent(BaseExternalLink);

export const PrimaryDarkLink = PrimaryDarkButton.withComponent(NavLink);

export const PrimaryDarkExternalLink = PrimaryDarkButton.withComponent(BaseExternalLink);
